import styled from 'styled-components';

export const Panel = styled('table')`
  background-color: ${(props) => props.theme.colors.white};
  width: 100%;
  border-radius: 4px;
  box-shadow: 0 0 0 1px #e5e5e5;
  border-collapse: collapse;
`;

export const Header = styled('thead')`
  width: 600px;

  box-shadow: inset 0 -1px 0 0 #e5e5e5;
  background-color: #f9fafb;

  & th {
    height: 48px;
    height: 48px;
    text-align: left;
    vertical-align: middle;
    padding-left: 20px;
  }

  & svg {
    position: absolute;
    width: 19px;
    height: 19px;
  }

  & span {
    font-family: Inter;
    font-size: 14px;
    font-weight: 600;
    font-style: normal;
    line-height: 1.43;
    letter-spacing: normal;
    color: ${(props) => props.theme.colors.darkBlue};
    margin-left: 24px;
  }
`;

export const Body = styled('tbody')`
  color: ${(props) => props.theme.colors.darkBlue};

  & th,
  td {
    height: 24px;
    text-align: left;
    vertical-align: middle;
    font-weight: 600;
  }

  & th {
    color: #6e7a93;
    padding-left: 30px;
    width: 40%;
  }

  & tr {
    // height: 32px;

    &:first-of-type {
      & th,
      td {
        padding-top: 30px;
        padding-bottom: 17px;
      }
    }
    &:last-of-type {
      & th,
      td {
        padding-top: 22px;
        padding-bottom: 30px;
      }
    }
    &:nth-child(3) {
      & th,
      td {
        padding-top: 17px;
      }
    }
  }
`;

export const Spacing = styled('div')`
  padding: 30px;
`;
